<template>
  <div id="page-user-edit">
    <vx-card>
      <div id="user-edit-tab-info" class="vs-con-loading__container">
        <!-- Content Row -->
        <vs-row>
          <vs-col class="pr-0 md:pr-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
            <div class="w-full">
              <vs-input
                :disabled="fieldVisible"
                class="w-full mt-4"
                :label="$t(`COMPANIES.nit`)"
                v-model="data_local.nit"
                v-validate="'required'"
                name="nit"
              />
              <span class="text-danger text-sm" v-show="errors.has('nit')">{{ errors.first("nit") }}</span>
            </div>
          </vs-col>

          <vs-col
            class="pl-0 pr-0 md:pl-2 md:pr-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
          >
            <div class="w-full">
              <vs-input
                class="w-full mt-4"
                :label="$t(`COMPANIES.addressCompany`)"
                v-model="data_local.address"
                v-validate="'required'"
                name="address"
              />
              <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first("address") }}</span>
            </div>
          </vs-col>

          <vs-col class="pl-0 md:pl-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
            <div class="w-full">
              <vs-input
                :disabled="fieldVisible"
                class="w-full mt-4"
                :label="$t(`COMPANIES.contactEmail`)"
                v-model="data_local.email"
                type="email"
                v-validate="'required|email'"
                name="email"
              />
              <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
            </div>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col class="pr-0 md:pr-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
            <div class="w-full">
              <vs-input
                :disabled="fieldVisible"
                class="w-full mt-4"
                :label="$t(`COMPANIES.nameCompany`)"
                v-model="data_local.name"
                v-validate="'required'"
                name="name"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
            </div>
          </vs-col>

          <vs-col
            class="pl-0 pr-0 md:pl-2 md:pr-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
          >
            <div class="w-full">
              <vs-input
                class="w-full mt-4"
                :label="$t(`COMPANIES.personContact`)"
                v-model="data_local.contactPerson"
                v-validate="'required'"
                name="contactPerson"
              />
              <span class="text-danger text-sm" v-show="errors.has('contactPerson')">{{
                errors.first("contactPerson")
              }}</span>
            </div>
          </vs-col>

          <vs-col class="pl-0 md:pl-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
            <div class="w-full mt-4">
              <input class="hidden" v-model="phone" type="text" v-validate="'required'" name="phone" />
              <InputPhone
                :key="defaultCountry"
                :defaultCountry="defaultCountry"
                v-model="phone"
                @country-changed="getIndicative($event)"
                :value="String(phone)"
              ></InputPhone>
              <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first("phone") }}</span>
            </div>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col class="pr-0 md:pr-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="12">
            <div class="w-full mt-4">
              <label class="vs-input--label">{{ $t(`COMPANIES.department`) }}</label>
              <v-select
                @input="
                  getCities(data_local.departmentID);
                  data_local.cityID = '';
                "
                :reduce="departament => departament.dane"
                label="departament"
                v-model="data_local.departmentID"
                :clearable="false"
                :options="listDepartaments"
                v-validate="'required'"
                name="cityID"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
              <span class="text-danger text-sm" v-show="errors.has('cityID')">{{ errors.first("cityID") }}</span>
            </div>
          </vs-col>

          <vs-col
            class="pl-0 pr-0 md:pl-2 md:pr-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="12"
          >
            <div class="w-full mt-4">
              <label class="vs-input--label">{{ $t(`COMPANIES.city`) }}</label>
              <v-select
                :reduce="city => city.key"
                label="city"
                v-model="data_local.cityID"
                :clearable="false"
                :options="listCities"
                v-validate="'required'"
                name="cityID"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
              <span class="text-danger text-sm" v-show="errors.has('cityID')">{{ errors.first("cityID") }}</span>
            </div>
          </vs-col>

          <vs-col class="pl-0 md:pl-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="12">
            <div class="mt-4 w-full">
              <label v-if="!fieldVisible" class="vs-input--label">{{ $t(`COMPANIES.contractDate`) }}</label>
              <label v-else class="vs-input--label">{{ $t(`COMPANIES.expiredDate`) }}</label>
              <datepicker
                :disabledDates="disabledDates"
                :language="lang['es']"
                :format="format"
                :placeholder="$t(`COMPANIES.selectedDate`)"
                v-model="expireAccount"
                rules="'required'"
                name="expireAccount"
              ></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('expireAccount')">{{
                errors.first("expireAccount")
              }}</span>
            </div>
          </vs-col>

          <vs-col class="pl-0 md:pl-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="12">
            <div class="mt-4 w-full">
              <label class="vs-input--label">{{ $t(`COMPANIES.languages`) }}</label>
              <v-select
                :reduce="local => local.key"
                v-model="data_local.localeID"
                label="local"
                :clearable="false"
                :options="listLocales"
                v-validate="'required'"
                name="localeID"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
              <span class="text-danger text-sm" v-show="errors.has('localeID')">{{ errors.first("localeID") }}</span>
            </div>
          </vs-col>
        </vs-row>

        <!-- Permissions -->
        <vx-card class="mt-base" no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="AwardIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">{{ $t(`COMPANIES.titleCard`) }}</span>
              </div>
              <vs-divider />
            </div>
          </div>

          <div class="overflow-x-auto vx-col vx-row justify-start items-start">
            <table class="w-full md:w-1/2">
              <tr class="flex md:table-row justify-between">
                <th
                  class="font-semibold text-base text-left md:px-3 py-2"
                  v-for="(heading, index) in [$t(`COMPANIES.module`), $t(`COMPANIES.yes`)]"
                  :key="index"
                >
                  {{ heading }}
                </th>
              </tr>

              <tr class="flex md:table-row justify-between" v-for="(value, index) in functions1" :key="index">
                <td class="md:px-3 py-2">{{ $t(`COMPANIES.${value.value}`) }}</td>
                <td class="py-2">
                  <vs-checkbox v-model="selectFunctions" :vs-value="value.key" />
                </td>
              </tr>
            </table>

            <table class="w-full md:w-1/2">
              <tr class="hidden md:table-row">
                <th
                  class="font-semibold text-base text-left md:px-3 py-2"
                  v-for="(heading, index) in [$t(`COMPANIES.module`), $t(`COMPANIES.yes`)]"
                  :key="index"
                >
                  {{ heading }}
                </th>
              </tr>

              <tr class="flex md:table-row justify-between" v-for="(value, index) in functions2" :key="index">
                <td class="md:px-3 py-2">{{ $t(`COMPANIES.${value.value}`) }}</td>
                <td class="py-2">
                  <vs-checkbox v-model="selectFunctions" :vs-value="value.key" />
                </td>
              </tr>
            </table>
          </div>
        </vx-card>
        <vx-card v-if="selectFunctions.includes('dispatcher_uri')" class="mt-base" no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="SendIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">{{ $t(`COMPANIES.settingDispatcher`) }}</span>
              </div>
              <vs-divider />
            </div>
          </div>

          <vs-row>
            <vs-col
              class="pl-0 pr-0 md:pl-2 md:pr-2"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="6"
              vs-sm="12"
            >
              <div class="w-full">
                <vs-input
                  class="w-full mt-4"
                  :label="$t(`COMPANIES.enterToken`)"
                  v-model.trim="dispatchKey"
                  v-validate="'required|min:20|max:32'"
                  name="dispatchKey"
                />
                <span class="text-danger text-sm" v-show="errors.has('dispatchKey')">{{
                  errors.first("dispatchKey")
                }}</span>
              </div>
            </vs-col>

            <vs-col
              class="pl-0 pr-0 md:pl-2 md:pr-2"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="6"
              vs-sm="12"
            >
              <div class="w-full">
                <vs-input
                  class="w-full mt-4"
                  :label="$t(`COMPANIES.EnterUrl`)"
                  v-model.trim="dispatchUrl"
                  v-validate="'required|url:require_protocol'"
                  name="dispatchUrl"
                />
                <span class="text-danger text-sm" v-show="errors.has('dispatchUrl')">{{
                  errors.first("dispatchUrl")
                }}</span>
              </div>
            </vs-col>
          </vs-row>
        </vx-card>

        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button v-if="!fieldVisible" class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{
                $t(`COMPANIES.btnCreate`)
              }}</vs-button>
              <vs-button v-else class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{
                $t(`COMPANIES.update`)
              }}</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="clear">{{
                $t(`COMPANIES.btnClean`)
              }}</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import moment from "moment";
import InputPhone from "@/components/Input-phone.vue";
import Api from "@/helpers/api";
import { loading, closeLoding, notify } from "@/helpers/$vs";
import { ES, EN, PT } from "./validate-user";
import Utils from "@/helpers/Utils.js";

import { Validator } from "vee-validate";

export default {
  props: {
    keyCompany: {
      required: false
    }
  },
  components: {
    vSelect,
    Datepicker,
    InputPhone
  },
  data() {
    return {
      dispatchKey: "",
      dispatchUrl: "",
      listCities: [],
      listDepartaments: [],
      listLocales: [],
      departamentId: "",
      phone: "",
      defaultCountry: 57,
      indicative: "+",
      selectFunctions: [],
      indicative: "",
      lang,
      format: "dd MMMM yyyy",
      data_local: {
        name: "",
        address: "",
        email: "",
        nit: "",
        contactPerson: "",
        cityID: "",
        departmentID: "",
        expireAccount: "",
        localeID: "",
        cellPhone: ""
      },
      expireAccount: moment().add(7, "days").toDate(),
      disabledDates: {
        // to: new Date(moment().format('YYYY'), moment().subtract(1,'month').format('M'), moment().format('D')),
        to: moment().add(7, "days").toDate()
      },
      functions1: [
        // {
        //   key: 'standar_forms',
        //   value: 'Formularios standard'
        // },
        {
          key: "multi_forms",
          value: `multiForms`
        },
        {
          key: "sub_forms",
          value: `subForms`
        },
        {
          key: "view_responses",
          value: `moduleAnswer`
        },
        {
          key: "data_origin",
          value: `dataSource`
        },
        // {
        //   key: 'data_origin_offline',
        //   value: 'Origen de datos offline'
        // },
        // {
        //   key: 'forms_with_ml',
        //   value: 'Machine learning'
        // },
        // {
        //   key: 'form_validator',
        //   value: 'Validador de formularios'
        // },
        {
          key: "notifications",
          value: `notify`
        },
        {
          key: "serviforms_connect",
          value: `connectServi`
        },
        {
          key: "serviforms_app",
          value: `appServi`
        }
      ],
      functions2: [
        // {
        //   key: 'serviforms_connect',
        //   value: 'Conección a ServiForms'
        // },
        {
          key: "filter_and_export",
          value: `filterExportData`
        },
        // {
        //   key: 'analytics_datastudio',
        //   value: 'Analítica de datos (dasboard)'
        // },
        // {
        //   key: 'analytics_3rd_party',
        //   value: 'Analítica de datos para terceros'
        // },
        {
          key: "private_apps",
          value: `accessApi`
        },
        // {
        //   key: 'faq',
        //   value: 'Preguntas y respuestas'
        // },
        {
          key: "showcase",
          value: `showCase`
        },
        {
          key: "bot_forms",
          value: `Bots`
        },
        {
          key: "visits",
          value: `visits`
        },
        {
          key: "dispatcher_uri",
          value: `Dispatcher`
        }
      ],
      locale: {
        es: ES,
        en: EN,
        pt: PT
      }
    };
  },
  computed: {
    FullNumberPhone() {
      return this.indicative + this.phone.trim().replace(/ /g, "");
    },
    expireAccountFormat() {
      return moment(this.expireAccount).format("YYYY-MM-DD");
    },
    status_local: {
      get() {
        return { label: this.capitalize(this.data_local.status), value: this.data_local.status };
      },
      set(obj) {
        this.data_local.status = obj.value;
      }
    },
    role_local: {
      get() {
        return { label: this.capitalize(this.data_local.role), value: this.data_local.role };
      },
      set(obj) {
        this.data_local.role = obj.value;
      }
    },
    validateForm() {
      return !this.errors.any();
    },
    fieldVisible() {
      return this.keyCompany === null ? false : true;
    }
  },
  methods: {
    getIndicative(event) {
      this.indicative = "+";
      this.indicative += event.dialCode;
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      /* eslint-disable */

      if (!this.validateForm) return;

      this.$validator.validateAll().then(result => {
        if (result) {
          this.data_local.cellPhone = this.FullNumberPhone;
          this.data_local.expireAccount = moment(this.expireAccount).format("YYYY-MM-DD");
          if (this.selectFunctions.includes("dispatcher_uri") && !Utils.validateUrl(this.dispatchUrl, "API dispacher"))
            return;

          loading(null, "#user-edit-tab-info");

          if (!this.fieldVisible) return this.saveCompany(this.data_local);
          else return this.updateCompany(this.data_local);
        } else {
          console.log("Error validate");
        }
      });
    },
    async saveCompany(data) {
      try {
        const { key } = this.listDepartaments.find(departament => departament.dane === data.departmentID);
        let newData = { ...data };
        newData.departmentID = key;

        const result = await Api.post("/companies", newData);
        await this.addFunctionalities(result.data.id, data.expireAccount);
        // this.clear();
        this.$emit("changeTab", 0);
        notify(this.$t(`COMPANIES.company`), this.$t(`COMPANIES.successCompany`));
      } catch (error) {
        console.log("Error: saveCompany ", error);
      } finally {
        closeLoding("user-edit-tab-info");
      }
    },
    async addFunctionalities(id_company, expire_account, service = true) {
      let data = {
        companyID: id_company,
        expire_account: expire_account,
        standar_forms: true,
        form_validator: true,
        dispatcher_uri: false
      };

      let objectFunctions = {};

      for (let i of this.selectFunctions) objectFunctions[i] = true;
      data = { ...data, ...objectFunctions };
      if (objectFunctions["dispatcher_uri"]) {
        data.dispatchKey = this.dispatchKey;
        data.dispatchUrl = this.dispatchUrl;
      }
      if (service) return await Api.post("/features", data);
      return await Api.put(`/features/${id_company}`, data);
    },
    async updateCompany(data) {
      const { key } = this.listDepartaments.find(departament => departament.dane === data.departmentID);
      try {
        const newData = {
          // name: data.name, //Este campo no es editable
          address: data.address,
          cellPhone: data.cellPhone,
          contactPerson: data.contactPerson,
          expireAccount: data.expireAccount,
          departmentID: key,
          cityID: data.cityID,
          localeID: data.localeID
        };
        await Api.put(`/companies/${this.keyCompany}`, newData);
        await this.addFunctionalities(this.keyCompany, newData.expireAccount, false);
        notify(this.$t(`COMPANIES.company`), this.$t(`COMPANIES.updateSuccess`));
        this.$emit("changeTab", 0);
      } catch (error) {
        console.log("Error: updateCompany ", error);
        if (error.status === 400 && error.data.reason === "Functionality is missing") {
          this.addFunctionalities(this.keyCompany, data.expireAccount);
        } else if (
          error.status === 400 &&
          error.data.reason === "The date is invalid, and should be a minimum of one week from today"
        ) {
          notify(this.$t(`COMPANIES.company`), this.$t(`COMPANIES.alertDateExpired`), "warning");
        }
      } finally {
        closeLoding("user-edit-tab-info");
      }
    },
    async getDepartaments() {
      try {
        const result = await Api.get("/departments");
        this.listDepartaments = result.data.map(departament => ({
          departament: departament.name,
          dane: departament.dane,
          key: departament.key
        }));
      } catch (error) {
        console.log("Error: getCities", error);
      }
    },
    async getCities(dane) {
      try {
        const result = await Api.get(`/departments/${dane}/cities`);
        this.listCities = result.data.map(city => ({
          city: city.name,
          key: city.key
        }));
      } catch (error) {
        this.listCities = [];
        console.log("Error: getCities", error);
      }
    },
    async getLocale() {
      try {
        const result = await Api.get("/locales");
        this.listLocales = result.data.map(local => ({
          local: this.$t(`LOCALES.${local.name}`),
          key: local.key
        }));
      } catch (error) {
        console.log("Error: getCities", error);
      }
    },
    async getCompany(key) {
      try {
        const result = await Api.get(`/companies/${key}`);

        const { name, address, email, nit, contactPerson, cityID, departmentID, expireAccount, localeID, cellPhone } =
          result.data;
        this.expireAccount = moment(expireAccount).toDate();

        if (departmentID) {
          const { dane } = this.listDepartaments.find(departament => departament.key === departmentID) || {
            dane: false
          };

          if (dane) {
            await this.getCities(dane);
            this.data_local = {
              name,
              address,
              email,
              nit,
              contactPerson,
              cityID,
              departmentID: dane,
              expireAccount,
              localeID,
              cellPhone
            };
          } else {
            this.data_local = { name, address, email, nit, contactPerson, cityID, expireAccount, localeID, cellPhone };
          }
        } else {
          this.data_local = { name, address, email, nit, contactPerson, cityID, expireAccount, localeID, cellPhone };
        }

        this.phone = cellPhone.slice(-10);
        this.defaultCountry = parseInt(cellPhone.slice(0, -10));
        this.getFunctions(key);
      } catch (error) {
        console.log("Error: getCompany ", error);
      }
    },
    async getFunctions(id_company) {
      try {
        const result = await Api.get(`/features/${id_company}`);
        this.selectFunctions = result.data.features || [];
        (this.dispatchKey = result.data.dispatchKey), (this.dispatchUrl = result.data.dispatchUrl);
      } catch (error) {
        console.log("Error: getFunctions ", error);
      }
    },
    clear() {
      this.defaultCountry = 57;
      this.phone = "";
      (this.dispatchKey = ""), (this.dispatchUrl = "");
      this.data_local = {
        name: "",
        address: "",
        email: "",
        nit: "",
        contactPerson: "",
        cityID: "",
        expireAccount: "",
        localeID: "",
        cellPhone: ""
      };
      setTimeout(() => (this.selectFunctions = []), 1000);
    }
  },
  watch: {
    "_i18n.locale": function (value) {
      Validator.localize(value, this.locale[value]);
    }
  },
  async mounted() {
    Validator.localize(this._i18n.locale, this.locale[this._i18n.locale]);
    loading(null, "#user-edit-tab-info");
    await this.getDepartaments();
    await this.getLocale();

    if (this.keyCompany !== null) await this.getCompany(this.keyCompany);
    closeLoding("user-edit-tab-info");
  },
  destroyed() {
    this.$emit("destroy");
  }
};
</script>

<style lang="scss">
.colombia {
  width: 30px;
  height: 20px;
  background: red;
}
</style>
